import teaserContainer from './teaser-container';

/**
 * @param {Array<Object>} promoRows - promo rows data.
 * @returns {string} product tile HTML
 */
export default promoRows => {
    return `
    <div class="promotional-rows-wrapper">
        ${promoRows.map(promoRow => {
            const assetHeightStyle = promoRow.height ? `height:${promoRow.height}px;` : '';
            const additionalClass = promoRow.height ? 'custom-height' : '';

            return `
            <div class="promotional-row ${additionalClass}" data-position="${promoRow.row}" style="${assetHeightStyle}">
                ${teaserContainer(promoRow.customizedAssets)}
            </div>`;
        })}
    </div>`;
};
